<template>
  <div class="mt-4" :key="componentKey">
    <p class="p-0 m-0 mb-1 ms-1 mensajeEditable" v-if="isEditable">
      <i class="fa-solid fa-circle-exclamation me-1"></i>
      Edite los m3/s de la celda según el criterio deseado ó reinicie los datos al estado
      inicial
      <i class="fa-solid fa-rotate iconReset" @click="resetValues" title="Restaurar valores por defecto"></i>
    </p>
    <!-- Tabla de datos-->

    <div class="table-responsive mt-3" v-if="localDataSet && localDataSet.columnas">
      <table class="table table-hover">
        <thead class="table-light">
          <!-- Primera serie de columnas-->

          <tr class="text-center">
            <th v-for="(item, index) in localDataSet.columnas" v-bind:key="index" :colspan="item.colspan">
              {{ item.label }}
            </th>
          </tr>

          <!-- SubColumnas-->

          <tr class="text-center">
            <template v-for="item in localDataSet.columnas">
              <th v-for="(item2, index2) in item.subLabels" v-bind:key="index2">
                {{ item2 }}
              </th>
            </template>
          </tr>
        </thead>
        <tbody :id="`${this.globalID}`" class="text-center dataTable">
          <tr v-for="(item, index) in localDataSet.filas" :key="index" :style="!esModificable(item.fecha, index)
            ? ' '
            : (new Date(item.fecha) == new Date() || (item.fecha.split('/')[0] !== '01' && item.fecha.split('/')[0] !== '15'))
              ? 'font-weight: bold;'
              : ''">
            <td style="background-color: inherit;">{{ item.fecha }}</td>
            <td style="background-color: inherit;">{{ parseFloat(item.ndias).toFixed(0) }}</td>
            <template v-for="(itemHead, indexHead) in localDataSet.columnas" :key="indexHead">
              <template v-for="(item2, index2) in item.masasAgua" :key="index2">
                <td :contenteditable="false" editado="false" :id="`${this.globalID}/${index}/${index2}/caudal`"
                  @keydown="isEditable == true && esModificable(item.fecha, index) ? onKeyDown($event, item, item2) : ''"
                  @blur="isEditable == true && esModificable(item.fecha, index) ? onBlur($event) : ''"  v-if="
                      item2.caudal &&
                      //item2.caudal.value && 
                      itemHead.label == item2.label
                    "
                  :class="this.$route.fullPath != '/newplan/bestplan' || item2.label == 'Total Aducido' && esModificable(item.fecha, index) ? 'unselectable' : ''">
                  {{ item2.caudal.value && item2.caudal.value != null && item2.caudal.value != "-" ?
                    parseFloat(item2.caudal.value).toFixed(3) : "-" }}
                </td>
                <td :contenteditable="esModificable(item.fecha, index) && isEditable"
                  :class="item2.label == 'Total Aducido' && esModificable(item.fecha, index) ? 'unselectable' : ''"
                  editado="false" :id="`${this.globalID}/${index}/${index2}/extraido`"
                  @keydown="isEditable && esModificable(item.fecha, index) ? onKeyDown($event, item, item2) : ''"
                  @blur="isEditable && esModificable(item.fecha, index) ? onBlur($event) : ''"  v-if="
                      item2.extraido &&
                      //item2.extraido.value &&
                      itemHead.label == item2.label
                    ">
                  {{ item2.extraido.value && item2.extraido.value != null && item2.extraido.value != "-" ?
                    parseFloat(item2.extraido.value).toFixed(3) : "-" }}
                </td>
              </template>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from 'moment';

export default {
  name: "DataTable",
  props: {
    globalID: {
      type: String,
    },
    dataSet: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    planFromDataBase: {
      type: Boolean,
      default: true,
    },
    tipoAño: {
      type: String,
      default: false
    },
    interruptor: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localDataSet: {},
      backupDataSet: {},
      componentKey: 0,
      counter: 0,
      colorMinilla: "#b8cce4",
      colorMelonares: "#ebf1de",
      colorGergal: "#fcd5b4",
      pos: []
    };
  },
  watch: {
    dataSet: function (newVal, oldVal) {
      //console.log("DATASET", newVal);
      if (newVal) {
        this.localDataSet = this.copyObject(newVal);
        //console.log("lcoalDaS", this.localDataSet)
        if (this.pos.length == 0) {
          this.backupDataSet = this.copyObject(newVal);
          this.counter++;
        }
        return newVal;
      }
    },
    v_selectedYear: function (newVal, oldVal) {
      this.counter = 0;
    },
    localDataSet: function (newVal, oldVal) {
      //console.log("localDataSet", newVal);
    }
    //   'localDataSet.filas': {
    //   handler(newVal, oldVal) {
    //     this.agregarFilaActual();
    //   },
    //   deep: true,
    // }


  },
  computed: { ...mapState("planner", ["v_selectedYear"]) },
  components: {},
  async mounted() {

    // Cargamos uan copia para manipular los elementos en caso de que hagan falt
    if (
      this.dataSet &&
      this.dataSet != null &&
      Object.entries(this.dataSet).length !== 0
    ) {
      this.localDataSet = this.copyObject(this.dataSet);
      this.backupDataSet = this.copyObject(this.localDataSet);
      //console.log("DS", this.backupDataSet)
    }
  },
  methods: {


    // agregarFilaActual() {
    //   const hoy = new Date();
    //   const fechaHoy = `${String(hoy.getDate()).padStart(2, "0")}/${String(hoy.getMonth() + 1).padStart(2, "0")}`; // Formato: DD/MM
    //   const nuevaFila = {
    //     fecha: fechaHoy,
    //     ndias: 17, // Número de días asociado a la nueva fila
    //     masasAgua: [], 
    //     highlight: true,
    //   };

    //   // Encuentra el índice de la quincena actual
    //   const indiceQuincenaActual = this.localDataSet.filas.findIndex(item => {
    //     const [dia, mes] = item.fecha.split("/").map(Number);
    //     const fechaItem = new Date(hoy.getFullYear(), mes - 1, dia);

    //     // Determina si pertenece a la quincena actual
    //     return (
    //       fechaItem.getMonth() === hoy.getMonth() &&
    //       ((fechaItem.getDate() <= 15 && hoy.getDate() <= 15) || // Primera quincena
    //        (fechaItem.getDate() > 15 && hoy.getDate() > 15))    // Segunda quincena
    //     );
    //   });

    //   // Inserta la nueva fila debajo de la quincena actual
    //   if (indiceQuincenaActual !== -1) {
    //     // Verifica que no haya una fila con la fecha de hoy ya existente
    //     const existeHoy = this.localDataSet.filas.some(fila => fila.fecha === fechaHoy);
    //     if (!existeHoy) {
    //       this.localDataSet.filas.splice(indiceQuincenaActual + 1, 0, nuevaFila);
    //     }
    //   } else {
    //     // Si no se encuentra la quincena actual, simplemente agrega al final
    //     this.localDataSet.filas.push(nuevaFila);
    //   }
    // },

    //Cada vez que se pulse una tecla se comprueba primero si es Enter, en cuyo caso impedimos que se ejecute el salto de linea
    //y mandamos el flujo a onBlur, que es donde está la lógica de almacenamiento de datos. Asi emulamos que con Enter el
    //usuario confirma la acción.
    //Después comprobamos con la expresión regular que en el innerHTML de la celda, que será el valor a almacenar, solo pueda
    //haber numeros y un solo punto para mantener la cohesión de datos con el dataprocessing y la base de datos.
    //Permitimos el uso del Backspace para que pueda borrar, las flechas izquierda y derecha.
    onKeyDown(e, item, item2) {
      if (e.key === "Enter") {
        e.preventDefault();
        e.currentTarget.innerHTML = e.currentTarget.innerHTML.replace(/<br>/g, "").trim();
        e.currentTarget.blur();
      } else if (
        e.key !== "Backspace" &&
        e.key !== "Tab" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight" &&
        e.key !== "Delete"
      ) {
        let currentValue = e.currentTarget.textContent.trim();
        let cursorPosition = window.getSelection().getRangeAt(0).startOffset; // Posición del cursor

        // Permitir '-' solo si es el primer carácter o si se va a insertar al inicio
        if (e.key === "-" && cursorPosition === 0 && !currentValue.includes("-")) {
          return;
        }

        let newValue =
          currentValue.slice(0, cursorPosition) + e.key + currentValue.slice(cursorPosition);

        var rgx = /^-?\d*\.?\d*$/; // Permitir negativo en cualquier momento al principio

        if (!rgx.test(newValue)) {
          e.preventDefault();
        }
      }

      this.dataSet.filas = this.dataSet.filas.map(fila =>
        fila.fecha === item.fecha ? item : fila
      );

      let cell = e.currentTarget;
      let dataCell = cell.id.split("/");
      this.pos = dataCell;
      //console.log(this.pos, "posicion")
      this.$emit("updateValues", this.dataSet, this.pos);

    },

    onBlur(e) {
      let cell = e.currentTarget;
      cell.innerHTML = cell.innerHTML.replace(/<br>/g, "").trim();

      let value = cell.textContent.trim();
      if (value === "" || value === "-") {
        cell.textContent = "0";
      } else {
        cell.textContent = value;
        cell.setAttribute("editado", true);
        cell.style.backgroundColor = "lightgreen";
      }

      let dataCell = cell.id.split("/");
      this.pos = dataCell;
      this.checkCellAndUpdatePlan(cell, dataCell);
    }


    ,
    //Almacenamos la celda, consiguiendo su id a través del evento.
    //El id tiene la estructura dada en el v-for correspondiente:
    //<tipoDePlan>/<indice de fila>/<indice de masa de agua>/<tipo de dato> (extraido o caudal)
    //Con el split en "/" obtenemos la posicion de la celda dentro del dataSet del plan. Le pasamos los valores al
    //método que hace comprobaciones y actualizaciones en el dataSet del plan correspondiente.

    //Comprobaciones y actualizaciones en base al nombre del plan dentro de un switch:
    // - Usamos el atributo de celda personalizado "editado" para comprobar si es la primera vez que se modifica,
    //   no alterando así el fondo.
    // - Si lo deja vacío lo ponemos en último valor válido guardado para no enviar nulo al dataprocessing.
    // - Finalmente, si es un valor válido diferente al anterior, se hace la llamada al método de vuex para
    //   actualizar el dataSet del Plan, se actualizan la variable editado y se cambia el color de fondo de la celda.
    async checkCellAndUpdatePlan(cell, dataCell) {
      let cellValue = this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]][
        dataCell[3]
      ].value;
      if (cell.innerHTML.length == 0) {
        cell.innerHTML = cellValue;
      } else if (cell.innerHTML != cellValue && cell.innerHTML != "-") {
        // Ojo que se requiere reinsertar como float en vez de texto
        cell.setAttribute("editado", true);
        cell.style.backgroundColor = "lightgreen";
        let fakeDataset;

        if (this.globalID == "planAduccionTable") {
          if ([dataCell[3]] == "extraido") {
            fakeDataset = {
              [dataCell[3]]: {
                value: cell.innerHTML,
                color: "lightgreen",
              },
              caudal: {
                value: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]].caudal
                  .value,
                color: "lightgreen",
              },
              label: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]].label,
              editado: true,
            };
          } else {
            fakeDataset = {
              [dataCell[3]]: {
                value: cell.innerHTML,
                color: "lightgreen",
              },
              extraido: {
                value: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]]
                  .extraido.value,
                color: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]]
                  .extraido.color,
              },
              label: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]].label,
              editado: true,
            };
          }
        } else {
          fakeDataset = {
            [dataCell[3]]: {
              value: cell.innerHTML,
            },
            label: this.localDataSet.filas[dataCell[1]].masasAgua[dataCell[2]].label,
            editado: true,
          };
        }
        this.localDataSet.filas[dataCell[1]].masasAgua.splice(
          [dataCell[2]],
          1,
          fakeDataset
        );
        this.pos = dataCell;
        this.emitValues(this.localDataSet, dataCell);
      }
    },

    resetCellColors() {
      let cells = document.getElementById(this.globalID).getElementsByTagName("td");
      if (cells.length > 0) {
        for (let j = 0; j < cells.length; j++) {
          if (cells[j].getAttribute("editado") === "true") {
            cells[j].style.backgroundColor = "";
          }
        }
      }
    },

    resetValues() {
      //console.log(this.backupDataSet,"backup")
      this.localDataSet = this.copyObject(this.backupDataSet);
      // Forzar renderizando del encapulsador html
      this.componentKey += 1;
      //Reiniciamos colores en ambos casos
      this.resetCellColors();
      this.$emit("resetSelect");
      if (this.pos.length > 0) {
        this.$emit("updateValues", this.localDataSet, this.pos);
      }
      this.pos = [];
    },

    //Funcion para copiar el objeto y que se deslinke la misma referencia en memoria
    copyObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    emitValues(newValues, pos) {
      //console.log(pos,"posicion")
      this.$emit("updateValues", newValues, pos);
    },

    convertirFecha(ddMMYYYY) {
      const [dia, mes] = ddMMYYYY.split('/').map(Number);
      // const año = new Date().getFullYear();
      return new Date(`${this.v_selectedYear}-${mes}-${dia}`);
    },
    esModificable(fecha, index) {
      let [dia, mes, anio] = fecha.split('/').map(Number);
      if (!anio) {
        anio = this.v_selectedYear;
      } else if (anio < 1000) {
        anio = '20' + anio;
        //console.log("anio", anio);
      }
      const fechaConvertida = new Date(`${anio}-${mes}-${dia}`);
      let condicion;
      if (this.localDataSet.filas[index + 1] == undefined) {
        condicion = fechaConvertida > new Date();
        //console.log("condicion", fechaConvertida);
      } else {
        let [dia, mes, anio] = this.localDataSet.filas[index + 1].fecha.split('/').map(Number);
        if (!anio) {
          anio = this.v_selectedYear;
        } else if (anio < 1000) {
          anio = '20' + anio;
        }
        const fechaSiguiente = new Date(`${anio}-${mes}-${dia}`);
        //console.log("fechaSiguiente", fechaSiguiente);
        condicion = new Date() < fechaSiguiente;
      }
      //console.log("condicion final", condicion);
      //return (condicion || (this.$route.fullPath == "/newplan/preconfigure?reuseplan=true" && !this.interruptor)) || this.$route.fullPath == "/newplan/preconfigure" || condicion;
      //console.log("ruta", this.$route.fullPath, ((this.$route.fullPath == "/newplan/preconfigure?reuseplan=true" && !this.interruptor)) || this.$route.fullPath == "/newplan/preconfigure" ||  this.$route.fullPath == "/newplan/bestplane",((this.$route.fullPath == "/newplan/preconfigure?reuseplan=true" && !this.interruptor)),this.$route.fullPath == "/newplan/preconfigure",this.$route.fullPath == "/newplan/bestplan");
      return ((this.$route.fullPath == "/newplan/preconfigure?reuseplan=true" && !this.interruptor)) || this.$route.fullPath == "/newplan/preconfigure" ||  this.$route.fullPath == "/newplan/bestplan";
    },

  },
};
</script>

<style scoped>
/* Estilo de la tabla */
table {
  border: 1px solid #dfe6ec;
}

table th {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}

table td {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}

.imgEmptyData {
  max-height: 10rem;
}

.noteBg {
  font-size: 0.876rem;
  text-align: justify;
}

.mensajeEditable {
  font-size: 0.8rem;
  font-style: oblique;
  color: #af4444;
}

.iconReset {
  cursor: pointer;
}

.iconReset:hover {
  cursor: pointer;
  transition: 1.5s;
  transform: rotate(360deg);
  -ms-transform: rotate(360deg);
  -webkit-transform: rotate(360deg);
}

.unselectable {
  /*background-color: #ddd;*/
  cursor: not-allowed;
}

.unabailable {
  background-color: rgba(112, 100, 100, 0.793) !important;
}

.highlight-row {
  background-color: lightblue !important;
  /* O el color que prefieras */
}

.minilla {
  background-color: rgb(184, 204, 228) !important;
}


.melonares {
  background-color: rgb(235, 241, 222) !important;
}

.gergal {
  background-color: rgb(252, 213, 180) !important;
}
</style>